import { Box, useColorMode, useColorStyle } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { useOrgStore } from 'src/models/useOrgModel';

import MenuWithLabel from '../Menu';

const Organization = ({
  allOrgItem = true,
  showLabel = true,
  ...props
}: {
  allOrgItem?: boolean;
  showLabel?: boolean;
  [key: string]: any;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const { orgId, switchOrgId, orgs, defaultSingleOrgId } = useOrgStore();

  const handleClick = (event: any) => {
    const key = event.target.getAttribute('value');
    switchOrgId(key);
  };

  const orgInfos = allOrgItem ? orgs : orgs?.filter((x) => x.key !== 'all');
  const currentOgrId = allOrgItem ? orgId : defaultSingleOrgId;
  return (
    <Box>
      {showLabel && (
        <Box
          as="span"
          position="static"
          fontSize="14px"
          lineHeight="25px"
          mr="16px"
          color={colorStyle.color.secondary}
        >
          {t('common.label.currentOrganization')}:
        </Box>
      )}
      <MenuWithLabel
        menuItems={orgInfos || []}
        onClick={handleClick}
        selectedKey={currentOgrId || ''}
        {...props}
        minWidth={props.minWidth || 200}
        maxWidth={props.maxWidth || 200}
      />
    </Box>
  );
};
export default Organization;
